export default {
  LOAD_COMPETENCY_FORM_PAGE_START: 'LoadCompetencyFormPageStart',
  LOAD_COMPETENCY_FORM_PAGE_END: 'LoadCompetencyFormPageEnd',

  LOAD_COMPETENCY_AVAILABLE_STUDY_PROGRAMS_START: 'LoadCompetencyAvailableStudyProgamsStart',
  LOAD_COMPETENCY_AVAILABLE_STUDY_PROGRAMS_END: 'LoadCompetencyAvailableStudyProgamsEnd'
};